import React, {Component} from 'react';
import {Router, Route, browserHistory} from 'react-router'
import AppComponent from './App';

import {Provider} from 'react-redux'
import createStore  from '../store/createStore';
import NotFoundComponent from "components/modules/not-found/not-found";
import MapComponent from "components/modules/map/map";
import NewsComponent from "components/modules/news/news";
import NewsFullComponent from "components/modules/news/full";
import PageComponent from "components/modules/pages/page";
import FaqComponent from "components/modules/faq/faq";
import CarriersComponent from "components/modules/carriers/carriers";
import SoonComponent from "components/modules/soon/soon";
import EmailConfirmComponent from "components/modules/mobile/email-confirm/index";
import EmailChangeConfirmComponent from "components/modules/mobile/email-change-confirm/index";
import RegisterComponent from "components/modules/register/index";
import NewsAllComponent from "components/modules/news/news-all";
import NewsTagComponent from "components/modules/news/news-tag";
import ScheduleComponent from "components/modules/schedule/index";

export const store = createStore();

export default class Root extends Component {

    componentWillMount() {
        if (window.location.hostname !== 'localhost' && window.location.protocol === 'http:') {
            window.location.protocol = 'https:';
        }
        if (window.RNIS_SETTINGS.CITY_MURMANSK) {
            browserHistory.push('/map/road');
        }
    }

    render() {
        return (
            <Provider store={store}>
                <Router history={browserHistory}>
                    <Route path="" component={AppComponent}>

                        <Route path="/" component={NewsComponent} />

                        <Route path="/register" component={RegisterComponent}>
                            <Route path="/register/:type"/>
                        </Route>

                        <Route path="/map/:type" component={MapComponent}/>
                        <Route path="/:component/map" component={MapComponent}/>

                        <Route path="/news" component={NewsComponent}/>
                        <Route path="/news/all" component={NewsAllComponent}/>
                        <Route path="/news/tag/:tag" component={NewsTagComponent}/>
                        <Route path="/news/:uuid" component={NewsFullComponent}/>

                        <Route path="/faq" component={FaqComponent}/>

                        <Route path="/carriers" component={CarriersComponent}/>

                        <Route path="/schedule" component={ScheduleComponent}/>

                        <Route path="/page/:key" component={PageComponent}/>

                        <Route path="/soon/:page" component={SoonComponent}/>

                        <Route path="/mobile/confirm/:email/:code" component={EmailConfirmComponent}/>
                        <Route path="/mobile/confirm_change/:email/:code" component={EmailChangeConfirmComponent}/>

                        <Route path="*" component={NotFoundComponent}/>
                    </Route>

                </Router>
            </Provider>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Root.js